<template>
  <div>
    <div class="contract">
      <HeaderNL :groupService="dataContract.groupService"></HeaderNL>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>
      <p class="txt-tranf txt-center fonsize-20 magb20">
        <b
          >PHỤ LỤC<br />
          DỊCH VỤ TRẢ GÓP BẰNG THẺ TÍN DỤNG
        </b>
      </p>
      <p class="txt-center">
        (PL số: ...............
        <!-- <mark>{{ dataAppendix.code }}</mark> -->
        )
      </p>
      <p>Căn cứ:</p>
      <ol class="form-style2">
        <li>
          <span>
            Hợp đồng hợp tác chấp nhận thanh toán thẻ số
            <mark>{{ dataAppendix?.appendixNganluongConvert?.nganluongContractCode }}</mark>
          </span>
          <p class="magt10">
            (sau đây được viết tắt là “Hợp đồng”) ký ngày
            <mark v-if="dataAppendix.dateSignAppendixDTO">{{
              dataAppendix.dateSignAppendixDTO | formatDate
            }}</mark>
            <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
              dataAppendix.dateCreatedAppendixDTO | formatDate
            }}</mark>
            <mark v-else-if="dataContract.effectiveFromDTO">{{
              dataContract.effectiveFromDTO | formatDate
            }}</mark>
          </p>
        </li>
        <li>Nhu cầu và khả năng của hai Bên.</li>
      </ol>
      <p>
        Hôm nay, ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataContract.effectiveFromDTO">{{
          dataContract.effectiveFromDTO | formatDate
        }}</mark>
        ,
        {{
          checkCreatedDateNganluong(dataAppendix)
            ? 'tại trụ sở Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng, chúng tôi gồm có:'
            : 'tại trụ sở Công ty Cổ phần Công nghệ Vi Mô, chúng tôi gồm có:'
        }}
      </p>
      <p class="fonsize-16 txt-tranf flex">
        <b v-if="!checkCreatedDateNganluong(dataAppendix)"
          >BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b
        >
        <b v-else>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
      </p>
      <p v-if="checkCreatedDateNganluong(dataAppendix)">
        Trụ sở: Tầng 3, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <p v-else>
        Trụ sở: Tầng 12A, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <div class="form form-ext">
        <p>
          Điện thoại: 024 36320986
          <span class="ml-4" v-if="!checkCreatedDateNganluong(dataAppendix)"
            >Fax: 024 36320987</span
          >
        </p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tài khoản: 11001010157634</p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tại: Ngân hàng Maritimebank</p>

        <p v-if="checkCreatedDateNganluong(dataAppendix)">Mã số thuế: 0106001236</p>
        <p v-else>Mã số thuế: 0106393463</p>
        <p>
          Người đại diện:
          <b
            v-if="
              dataAppendix?.dateSignAppendixDTO ||
              dataAppendix?.dateCreatedAppendixDTO ||
              dataContract?.effectiveFromDTO
                ? (dataAppendix?.dateSignAppendixDTO ||
                    dataAppendix?.dateCreatedAppendixDTO ||
                    dataContract?.effectiveFromDTO) < new Date('2026-01-07').getTime()
                : new Date() < new Date('2026-01-07')
            "
            >ĐỖ CÔNG DIỄN</b
          >
          <b v-else>Ông NGUYỄN TIẾN LƯỢNG</b>
          <span class="ml-4"
            >Chức vụ: <b v-if="!checkCreatedDateNganluong(dataAppendix)">Tổng Giám Đốc</b
            ><b v-else>Phó Tổng Giám đốc kiêm Giám đốc BU Chuyển đổi số</b></span
          >
        </p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">
          Giấy ủy quyền số: 1302/2026/GUQ/NGANLUONG ngày 13/02/2026
        </p>
        <p>
          NVKD:
          <b>{{
            dataContract.saleInfoRes && dataContract.saleInfoRes.name
              ? dataContract.saleInfoRes.name
              : ''
          }}</b>
          <span class="ml-4">Điện thoại:</span>
          <b>{{
            dataContract.saleInfoRes && dataContract.saleInfoRes.mobile
              ? dataContract.saleInfoRes.mobile
              : ''
          }}</b>
        </p>
      </div>
      <p>và</p>
      <p class="fonsize-16 txt-tranf flex">
        <span class="nowrap"> <b>BÊN B:</b></span>
        <mark>
          <b>{{ customerInfo.merchantName }}</b>
        </mark>
      </p>
      <div class="form form-ext">
        <p>
          <span>Trụ sở: </span>
          <mark>
            {{ customerInfo.address }}

            <!-- {{ customerInfo.district }},
            {{ customerInfo.city }} -->
          </mark>
        </p>
        <p>
          Website:<mark v-if="customerInfo.website"> {{ customerInfo.website }}</mark>
        </p>
        <p>
          <span>Điện thoại:</span><mark>{{ customerInfo.mobile }}</mark>
          <span class="ml-4"> Fax: </span>
        </p>
        <p>
          Tài khoản:<mark> {{ customerInfo.accountNo }}</mark>
        </p>
        <p>
          Tại:<mark> {{ customerInfo.bankName }}</mark>
        </p>
        <p>
          <span>Mã số thuế:</span>
          <mark>
            {{ customerInfo.businessRegistrationNumber }}
          </mark>
        </p>
        <p>
          <span>Họ và tên người đại diện: </span
          ><mark
            ><b>{{ customerInfo.customerName }}</b></mark
          >
          <span class="ml-4"
            >Chức vụ: <mark v-if="customerInfo.position"> {{ customerInfo.position }}</mark></span
          >
        </p>
      </div>

      <p>Cùng thỏa thuận hợp tác và cam kết thực hiện những điều sau đây:</p>

      <ul class="new-style-ul">
        <li>
          <h1>NỘI DUNG HỢP TÁC</h1>
          <ul>
            <li>
              Bên A và Bên B đồng ý hợp tác thực hiện chương trình ưu đãi trả góp lãi suất 0% dành
              cho Chủ thẻ tín dụng (Chủ thẻ) Visa/Master/JCB của các ngân hàng được Bên A hỗ trợ
              theo Phụ lục hợp đồng này hoặc thông báo từ Bên A cập nhật theo từng thời điểm tại
              website hoặc ứng dụng của Bên A.
            </li>
            <li>
              Bên B thực hiện chương trình ưu đãi trả góp (Dịch vụ Trả góp) dành cho Chủ thẻ khi mua
              hàng hóa và thanh toán tại các địa điểm kinh doanh của Bên B và đồng ý thanh toán chi
              phí dịch vụ cho Bên A được nêu ở Nội dung hợp tác.
            </li>
            <li>
              Bên B chấp nhận thanh toán hàng hóa, dịch vụ bằng thẻ mà không thuyết phục chủ thẻ
              dùng phương tiện thanh toán khác.
            </li>
          </ul>
        </li>
        <li>
          <h1>NGUYÊN TẮC CHẤP NHẬN TRẢ GÓP BẰNG THẺ TÍN DỤNG</h1>
          <ul>
            <li>
              Loại thẻ hỗ trợ trả góp là THẺ TÍN DỤNG mang thương hiệu Napas, Visa, Master hoặc JCB
              (tuỳ theo từng ngân hàng) do các ngân hàng tại Việt Nam phát hành được liệt kê trong
              Phụ lục hợp đồng này
            </li>
            <li>
              Giá trị giao dịch thanh toán trả góp tối thiểu (số tiền mà khách hàng thanh toán trả
              góp) áp dụng theo quy định của từng ngân hàng (từ 2,000,000 VNĐ hoặc 3,000,000 VNĐ).
            </li>
            <li>
              Chỉ có các giao dịch khách hàng đã thanh toán và được ghi nhận thành công trên hệ
              thống ứng dụng dành cho điểm bán hàng của Bên A mới được tiến hành đối soát và thanh
              toán.
            </li>
            <li>
              Quy trình và điều kiện trả góp được áp dụng theo quy định của Ngân hàng phát hành thẻ
              từng thời kỳ.
            </li>
          </ul>
        </li>
        <li>
          <h1>QUYỀN VÀ TRÁCH NHIỆM CỦA BÊN A</h1>
          <ul>
            <li>
              Quảng cáo chương trình ưu đãi cho các khách hàng thông qua các phương tiện truyền
              thông của Bên A hoặc phối hợp với ngân hàng phát hành thẻ truyền thông quảng bá chương
              trình ưu đãi đến các tập khách hàng phù hợp để biết đến dịch vụ này tại các điểm kinh
              doanh của Bên B.
            </li>
            <li>Hỗ trợ giải đáp các thắc mắc theo yêu cầu của Khách hàng hoặc Bên B.</li>
            <li>
              Phối hợp các ngân hàng có tham gia chương trình trả góp lãi suất 0% để giải đáp và
              thực hiện đúng quyền lợi của khách hàng/chủ thẻ khi thực hiện giao dịch tại các điểm
              kinh doanh của Bên B và tham gia Chương trình này.
            </li>
            <li>
              Bên A có quyền nêu tên Bên B trong các chiến dịch quảng bá chương trình có nội dung
              phù hợp với loại hình kinh doanh của Bên B mà Bên A có thể thực hiện trong thời hạn
              của Hợp đồng.
            </li>
            <li>
              Được quyền kiểm tra việc thực hiện Hợp đồng của Bên B, nếu Bên B thực hiện không đúng
              hoặc từ chối không thực hiện các nội dung của Hợp đồng vì bất kỳ lý do nào, bao gồm
              nhưng không giới hạn việc không chấp nhận hoặc từ chối bán trả góp bằng thẻ tín dụng
              cho khách hàng, các chế độ giao hàng và hậu mãi cho Chủ thẻ, các hành vi mang tính
              phân biệt đối xử khi thanh toán bằng thẻ,… thì Bên A có quyền: (1) ngay lập tức đơn
              phương chấm dứt Hợp đồng và yêu cầu bồi thường các thiệt hại thực tế phát sinh (chi
              phí quảng cáo, maketing cho chương trình và chi phí thông báo trên báo giấy hoặc các
              phương tiện thông tin khác để thông báo về việc chấm dứt chương trình); và/hoặc (2)
              yêu cầu Bên B gửi thư và/hoặc công khai xin lỗi (các) khách hàng qua các phương tiện
              thông tin truyền thông và (3) hoàn lại cho khách hàng khoản tiền tương đương với giá
              trị của hình thức ưu đãi mà khách hàng đáng lẽ đã được nhận bằng tiền mặt hoặc quà
              tặng kèm theo (nếu có).
            </li>
            <li>
              Từ chối thực hiện quảng cáo cho Bên B nếu Bên B không tuân thủ các quy định tại Hợp
              đồng này hoặc vi phạm các quy định của pháp luật.
            </li>
            <li>
              Đảm bảo bí mật các thông tin về Bên B, chỉ được phép tiết lộ thông tin khi có yêu cầu
              của cơ quan chức năng theo quy định của pháp luật và phải thông báo cho Bên B về nội
              dung thông tin được tiết lộ.
            </li>
            <li>
              Thanh toán đầy đủ và đúng hạn các giao dịch hợp lệ phát sinh tại Bên B trừ đi tỷ lệ
              phí chuyển đổi trả góp và giao dịch thẻ như quy định trong Điều 3 của Hợp đồng.
            </li>
            <li>Giải quyết các yêu cầu tra soát, khiếu nại của Bên B</li>
          </ul>
        </li>
        <li>
          <h1>QUYỀN VÀ TRÁCH NHIỆM CỦA BÊN B</h1>
          <ul>
            <li>
              Cam kết thực hiện đúng quy trình và phương thức trả góp trên của bên A để đảm bảo
              quyền lợi cho chủ thẻ. Trường hợp Bên B không thực hiện lựa chọn chương trình trả góp
              trên của bên A cho chủ thẻ theo yêu cầu, giao dịch đó không được coi là giao dịch hợp
              lệ và Bên B phải chịu trách nhiệm đền bù chi phí phát sinh do không ghi nhận giao dịch
              trả góp cho chủ thẻ.
            </li>
            <li>
              Đồng ý thực hiện Chương trình ưu đãi cho khách hàng có thẻ tín dụng như nội dung Hợp
              đồng.
            </li>
            <li>
              Giới thiệu Chương trình ưu đãi đến khách hàng và thực hiện quảng cáo chương trình bằng
              một trong các phương tiện do Bên B quyết định.
            </li>
            <li>
              Hỗ trợ Bên A để dán các sticker, standee,… tại địa điểm kinh doanh hoặc treo banner,
              nội dung truyền thông tại website, fanpage,…. của Bên B để khách hàng biết đến dịch vụ
              này.
            </li>
            <li>
              Hợp tác với Bên A thực hiện Chương trình dành cho khách hàng có thẻ tín dụng theo đúng
              nội dung Hợp đồng và Phụ lục hợp đồng này.
            </li>
            <li>Thanh toán phần hỗ trợ lãi suất và phí dịch vụ cho Bên A theo thoả thuận</li>
            <li>
              Sử dụng nội dung thông tin, dữ liệu, hình ảnh, logo, tên thương mại trong các tài liệu
              quảng cáo chương trình ưu đãi Bên A theo Hợp đồng một cách hợp pháp và không vi phạm
              quyền sở hữu trí tuệ của Bên còn lại và/hoặc bất kỳ bên thứ ba nào.Đảm bảo đội ngũ
              nhân viên bán hàng tại các địa điểm kinh doanh đều nắm rõ Chương trình và các ưu đãi
              (nếu có) cũng như duy trì dịch vụ trả lời qua điện thoại một cách hiệu quả để giải đáp
              các thắc mắc của khách hàng liên quan đến Chương trình trả góp này.
            </li>
            <li>
              Chịu trách nhiệm hoàn toàn với khách hàng về những tranh chấp liên quan đến việc thực
              hiện chương trình ưu đãi, bao gồm nhưng không giới hạn các tranh chấp về việc chủ thẻ
              không được tham gia chương trình, không được hưởng các ưu đãi như thanh toán bằng tiền
              mặt; tranh chấp vì có sự phân biệt giá giữa các chủ thẻ, yêu cầu chủ thẻ trả thêm phụ
              phí đối với các giao dịch thanh toán tiền dịch vụ bằng thẻ so với thanh toán bằng tiền
              mặt…
            </li>
            <li>
              Chịu trách nhiệm hoàn toàn về chất lượng hàng hóa dịch vụ và các chế độ hậu mãi, bảo
              hành đối với hàng hóa đã bán cho Chủ thẻ.
            </li>
            <li>
              Mọi trường hợp sử dụng thông tin thuộc sở hữu hợp pháp của Bên A ngoài những nội dung
              đã thỏa thuận phải có ý kiến chấp thuận bằng văn bản của Bên A.
            </li>
            <li>
              Không đưa ra các thông lệ hay quy trình thanh toán mang tính phân biệt đối xử hoặc
              không khuyến khích việc sử dụng Thẻ tín dụng.
            </li>
            <li>
              Thanh toán phí hỗ trợ lãi suất cho Bên A trên từng giao dịch thành công và phí dịch vụ
              thẻ theo thoả thuận trong Hợp đồng chấp nhận thẻ đã ký và Phụ lục hợp đồng này.
            </li>
            <li>
              Không yêu cầu Khách hàng tham gia chương trình thanh toán thêm bất kỳ khoản chi phí
              nào liên quan đến việc mua hàng hóa bằng thẻ tín dụng và/hoặc không được áp dụng bất
              kỳ khoản phụ thu nào khác đối với khách hàng khi thanh toán bằng thẻ tín dụng thông
              qua của bên A.
            </li>
          </ul>
        </li>
        <li>
          <h1>PHÍ DỊCH VỤ TRẢ GÓP BẰNG THẺ TÍN DỤNG</h1>
          <p>
            Phí tham gia chương trình trả góp 0% (chưa bao gồm phí chấp nhận thanh toán thẻ tín dụng
            quy định tại Phụ lục Biểu phí và nguyên tắc chấp nhận thanh toán được đính kèm Hợp đồng
            mà hai bên đã ký) theo từng ngân hàng và theo từng chu kỳ trả góp như sau:
          </p>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head2">
                  <th width="15%" rowspan="2"><b>Ngân hàng</b></th>
                  <th colspan="9"><b>Kỳ hạn trả góp</b></th>
                  <th id="th8" width="15%" rowspan="2">
                    <b>Mức giao dịch tối thiểu (VNĐ)</b>
                  </th>
                </tr>
                <tr class="bg-head2">
                  <th width="10%"><b>3 tháng</b></th>
                  <th width="10%"><b>6 tháng</b></th>
                  <th width="10%"><b>9 tháng </b></th>
                  <th width="10%"><b>12 tháng </b></th>
                  <th width="10%"><b>15 tháng </b></th>
                  <th width="10%"><b>18 tháng</b></th>
                  <th width="10%"><b>21 tháng</b></th>
                  <th width="10%"><b>24 tháng</b></th>
                  <th width="10%"><b>36 tháng</b></th>
                </tr>
              </thead>
              <tbody
                v-for="(item, index) in dataAppendix?.appendixNganluongConvert &&
                dataAppendix?.appendixNganluongConvert?.creditFeeTable?.length > 0
                  ? dataAppendix?.appendixNganluongConvert?.creditFeeTable
                  : []"
                :key="index"
              >
                <tr>
                  <td class="txt-center">{{ item.bankName }}</td>
                  <td class="txt-center">
                    <span
                      style="background: yellow"
                      v-if="
                        item.listPeriod.filter(e => e.period === '3')[0] &&
                        item.listPeriod.filter(e => e.period === '3')[0].isDefaultFee === false
                      "
                    >
                      {{ '3' | mapA(item.listPeriod) }}
                    </span>
                    <span v-else>
                      {{ '3' | mapA(item.listPeriod) }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span
                      style="background: yellow"
                      v-if="
                        item.listPeriod.filter(e => e.period === '6')[0] &&
                        item.listPeriod.filter(e => e.period === '6')[0].isDefaultFee === false
                      "
                    >
                      {{ '6' | mapA(item.listPeriod) }}
                    </span>
                    <span v-else>
                      {{ '6' | mapA(item.listPeriod) }}
                    </span>
                  </td>
                  <td class="txt-center">
                    <span
                      style="background: yellow"
                      v-if="
                        item.listPeriod.filter(e => e.period === '9')[0] &&
                        item.listPeriod.filter(e => e.period === '9')[0].isDefaultFee === false
                      "
                    >
                      {{ '9' | mapA(item.listPeriod) }}
                    </span>
                    <span v-else>
                      {{ '9' | mapA(item.listPeriod) }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span
                      style="background: yellow"
                      v-if="
                        item.listPeriod.filter(e => e.period === '12')[0] &&
                        item.listPeriod.filter(e => e.period === '12')[0].isDefaultFee === false
                      "
                    >
                      {{ '12' | mapA(item.listPeriod) }}
                    </span>
                    <span v-else>
                      {{ '12' | mapA(item.listPeriod) }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span
                      style="background: yellow"
                      v-if="
                        item.listPeriod.filter(e => e.period === '15')[0] &&
                        item.listPeriod.filter(e => e.period === '15')[0].isDefaultFee === false
                      "
                    >
                      {{ '15' | mapA(item.listPeriod) }}
                    </span>
                    <span v-else>
                      {{ '15' | mapA(item.listPeriod) }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span
                      style="background: yellow"
                      v-if="
                        item.listPeriod.filter(e => e.period === '18')[0] &&
                        item.listPeriod.filter(e => e.period === '18')[0].isDefaultFee === false
                      "
                    >
                      {{ '18' | mapA(item.listPeriod) }}
                    </span>
                    <span v-else>
                      {{ '18' | mapA(item.listPeriod) }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span
                      style="background: yellow"
                      v-if="
                        item.listPeriod.filter(e => e.period === '21')[0] &&
                        item.listPeriod.filter(e => e.period === '21')[0].isDefaultFee === false
                      "
                    >
                      {{ '21' | mapA(item.listPeriod) }}
                    </span>
                    <span v-else>
                      {{ '21' | mapA(item.listPeriod) }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span
                      style="background: yellow"
                      v-if="
                        item.listPeriod.filter(e => e.period === '24')[0] &&
                        item.listPeriod.filter(e => e.period === '24')[0].isDefaultFee === false
                      "
                    >
                      {{ '24' | mapA(item.listPeriod) }}
                    </span>
                    <span v-else>
                      {{ '24' | mapA(item.listPeriod) }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span
                      style="background: yellow"
                      v-if="
                        item.listPeriod.filter(e => e.period === '36')[0] &&
                        item.listPeriod.filter(e => e.period === '36')[0].isDefaultFee === false
                      "
                    >
                      {{ '36' | mapA(item.listPeriod) }}
                    </span>
                    <span v-else>
                      {{ '36' | mapA(item.listPeriod) }}
                    </span>
                  </td>
                  <td class="text-center">
                    {{ item.minAmount | transformMoney }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p><b class="txt-under">LƯU Ý:</b></p>
          <p>
            - Đối với tất cả các Ngân hàng trả góp qua Bên A, khi thực hiện giao dịch trả góp, bên B
            ngoài việc tư vấn về quy trình, chính sách, cần khuyến cáo thêm tới chủ thẻ: không chủ
            động đăng ký trả góp với Ngân hàng qua bất kỳ hình thức nào khác ( sms, web, app mobile,
            nhận trả góp qua sale call theo chương trình riêng của Bank,....).
          </p>
          <p>
            - Yêu cầu thay đổi/ hủy thông tin đăng ký trả góp của Khách hàng chỉ áp dụng cho các
            giao dịch chưa được chuyển đổi trả góp thành công
          </p>
          <p>
            - Phí chuyển đổi trả góp trên đây có thể thay đổi theo biểu phí của Ngân hàng theo từng
            thời kỳ. Bên A có trách nhiệm thông báo cho bên B được biết về sự thay đổi này trước ít
            nhất 07 (bảy) ngày làm việc kể từ khi biểu phí mới được áp dụng. Trong vòng 07 ngày kể
            từ ngày nhận được thông báo, nếu bên B không có bất cứ phản hồi nào cho bên A qua email
            thì mức phí mới tự động được áp dụng.
          </p>
          <p>
            - Phí tham gia chương trình trả góp lãi suất 0% đã thu sẽ không được Bên A hoàn trả cho
            Bên B trong trường hợp chủ thẻ tự thực hiện tham gia chương trình trả góp với Ngân hàng.
          </p>
          <div class="ml-3">
            <p><b>(*)</b> Đối với <b>MaritimeBank</b>:</p>
            <p>
              Ngân hàng Maritimebank sẽ thu thêm chủ thẻ phí quản lý giao dịch trả góp trên tổng số
              tiền thanh toán của giao dịch trực tiếp và giao dịch qua Link như sau:
            </p>
            <p>
              - Kỳ hạn 3 tháng, 9 tháng, 12 tháng:
              <b>3% phí /số tiền thanh toán</b>
            </p>
            <p>- Kỳ hạn 6 tháng: <b>miễn phí</b></p>
            <p>Phí sẽ chia đều cho các kỳ trả góp.</p>
            <p><b>(**)</b> Đối với <b>FE Credit:</b></p>
            <p>
              Đơn vị phát hành thẻ sẽ thu thêm 2,99% phí chuyển đổi giao dịch trả góp (thu một lần
              và chưa bao gồm VAT) của chủ thẻ. Mức phí này được áp dụng cho tất cả các kì hạn trả
              góp, bao gồm: 9 tháng - 12 tháng - 15 tháng - 18 tháng
            </p>

            <p class="magb20">
              <b>(***)</b> Đối với <b>MCredit:</b> Đơn vị phát hành thẻ sẽ thu thêm phí chuyển đổi
              giao dịch trả góp
              <b>(thu một lần và chưa bao gồm VAT)</b>
              của chủ thẻ như sau:
            </p>
            <p>- Đối với các Giao dịch trả góp có giá trị từ 3.000.000 VNĐ trở lên:</p>
          </div>
          <div v-if="dataContract.lstMCreditFee" class="table-responsive">
            <table>
              <thead>
                <tr>
                  <th><b>Loại phí/Kỳ hạn</b></th>
                  <th v-for="(item, index) in dataContract.lstMCreditFee" :key="index">
                    <b>{{ item.key }}</b>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="txt-center">Phí chuyển đổi trả góp (MCredit thu của chủ thẻ)</td>
                  <td
                    class="txt-center"
                    v-for="(item, index) in dataContract.lstMCreditFee"
                    :key="index"
                  >
                    <b>{{ item.value }} %</b>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="ml-3">
              <p>
                - Đối với các Giao dịch trả góp có Giá trị từ 500.000 VNĐ - 2.999.999 VNĐ: 50.000
                VNĐ
              </p>
            </div>
          </div>
        </li>
        <li>
          <h1>QUY TRÌNH THỰC HIỆN GIAO DỊCH TRẢ GÓP BẰNG THẺ TÍN DỤNG</h1>
          <p>
            <b class="txt-under">Bước 1:</b> Bên B hướng dẫn các điều kiện, thủ tục của Dịch vụ Trả
            góp bằng thẻ tín dụng cho Chủ thẻ.
          </p>
          <p>
            <b class="txt-under">Bước 2:</b> Bên B mở ứng dụng của bên A, điền các thông tin giao
            dịch theo yêu cầu và thực hiện giao dịch thanh toán trả góp bằng thẻ. Nếu giao dịch
            thanh toán thành công, Bên B thực hiện giao hàng cho chủ thẻ và thông báo chủ thẻ cách
            trả góp với từng Ngân hàng theo hướng dẫn sau:
          </p>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head2">
                  <th
                    v-for="column in dataContract.installmentGuideConfig.columns"
                    :key="column.key"
                  >
                    <b>{{ column.title }}</b>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in dataContract.installmentGuideConfig.rows" :key="index">
                  <td class="txt-center">{{ index + 1 }}</td>
                  <td class="txt-center">{{ row.issuer }}</td>

                  <td
                    v-if="
                      index === 0 ||
                      row.process !== dataContract.installmentGuideConfig.rows[index - 1].process ||
                      row.note !== dataContract.installmentGuideConfig.rows[index - 1].note
                    "
                    class="txt-center merged-cell"
                    :rowspan="getRowspan(index)"
                  >
                    <b>{{ row.process }}</b>
                  </td>

                  <td
                    v-if="
                      index === 0 ||
                      row.process !== dataContract.installmentGuideConfig.rows[index - 1].process ||
                      row.note !== dataContract.installmentGuideConfig.rows[index - 1].note
                    "
                    class="txt-center merged-cell"
                    style="white-space: pre-line"
                    :rowspan="getRowspan(index)"
                  >
                    <b>{{ row.note }}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
        <li>
          <h1>ĐIỀU KHOẢN THI HÀNH</h1>
          <ul class="form-style2">
            <li>
              Phụ lục này là bộ phận không thể tách rời của Hợp đồng và các điều khoản khác của Hợp
              đồng vẫn được giữ nguyên. Các bên cam kết tuân thủ các quy định trong phụ lục Hợp đồng
              này.
            </li>
            <li>
              Phụ lục này có hiệu lực kể từ ngày đại diện có thẩm quyền của hai Bên tham gia ký kết.
              Thời hạn hiệu lực của Phụ lục này được xác định theo thời hạn hiệu lực của Hợp đồng
              nêu trên trừ khi hai bên có thỏa thuận khác bằng văn bản.
            </li>
            <li>
              Phụ lục này được lập thành 02 (hai) bản có nội dung và giá trị pháp lý như nhau, mỗi
              Bên giữ 01 (một) bản.
            </li>
          </ul>
        </li>
      </ul>

      <FooterNL
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></FooterNL>
    </div>
  </div>
</template>

<script>
  import HeaderNL from '../block/headerNL.vue'
  import FooterNL from '../block/footerNL.vue'
  export default {
    props: ['dataContract', 'appendix'],
    components: {
      HeaderNL,
      FooterNL,
    },
    data() {
      return {}
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      getRowspan() {
        return index => {
          const rows = this.dataContract.installmentGuideConfig.rows
          const current = rows[index]
          let count = 1

          for (let i = index + 1; i < rows.length; i++) {
            if (rows[i].process === current.process && rows[i].note === current.note) {
              count++
            } else {
              break
            }
          }

          return count
        }
      },
      dataAppendix() {
        return (
          this.appendix ??
          this.dataContract.lstAppendixNganluongConverts.find(e => e.isCreatedWithContract)
        )
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
